<template>
  <v-tabs centered show-arrows>
    <v-tab v-if="gameListEnabled" key="1" to="/#games">{{ $t('Games') }}</v-tab>
    <v-tab v-if="promotionEnabled" key="2" to="/#promotions">{{ $t('Promotions') }}</v-tab>
    <v-tab key="3" :to="{ name: 'tutorial.list'}">{{ $t('Tutorials') }}</v-tab>
    <v-tab key="4" :to="{ name: 'support'}">{{ $t('Support') }}</v-tab>
  </v-tabs>

</template>
<script>
import {config} from '~/plugins/config'

export default {
  computed: {
    promotionEnabled(){
      return config('settings.content.home.promotion.enabled')
    },
    gameListEnabled(){
      return config('settings.content.home.game_list.enabled')
    }
  }

}


</script>
